// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-checkbox[data-v-70f0a6eb],.el-radio[data-v-70f0a6eb]{margin-right:10px!important}.el-tabs[data-v-70f0a6eb]{width:700px;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
